import React from "react";
import AuthorsSection from "../components/authors/AuthorsSection";

export default function Authors(){
	return(
		<div>
			<AuthorsSection/>
		</div>
	);
}